import React from "react";
import { Reveal } from "@/components/blocks/Reveal";

export const SectionHeading = ({
  overline,
  title,
  description,
  align = "left",
  dark = false,
  className = "",
}) => {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex max-w-3xl flex-col ${alignCls} ${className}`}>
      {overline && <span className="overline text-brand-orange">{overline}</span>}
      <h2
        className={`mt-4 font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base leading-relaxed md:text-lg ${dark ? "text-white/70" : "text-muted-foreground"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeading;
